<template>
  <v-form
    ref="form"
    class="layout wrap justify-space-between"
    @keyup.native.enter="save"
  >
    <v-flex md6 xs12 class="pb-1">
      <div class="mr-lg-4">
        <label>Название шаблона</label>
        <v-text-field
          v-model="fields.name"
          height="48"
          solo
          :rules="[rules.required]"
        >
        </v-text-field>
        <v-radio-group
          v-model="type"
          :mandatory="false"
          class="checkBoxList pt-0 pb-1 mb-3"
        >
          <template #label>
            <div class="pb-2">Вид опроса. Посетитель может</div>
          </template>
          <v-layout column align-start class="mx-0">
            <div class="d-flex align-center">
              <v-radio value="one" class="my-0" :disabled="disabledOneMore">
                <template #label>
                  <span :class="disabledOneMore ? 'disabled' : ''" class="pl-2">
                    Выбрать только один ответ
                  </span>
                </template>
              </v-radio>
            </div>
            <div class="d-flex align-center mt-3 pt-1">
              <v-radio value="more" class="my-0" :disabled="disabledOneMore">
                <template #label>
                  <span :class="disabledOneMore ? 'disabled' : ''" class="pl-2">
                    Выбрать несколько ответов
                  </span>
                </template>
              </v-radio>
            </div>
            <div class="d-flex align-center mt-3 pt-1">
              <v-radio value="grade" class="my-0" :disabled="disabledGrade">
                <template v-slot:label>
                  <span :class="disabledGrade ? 'disabled' : ''" class="pl-2">
                    Оценить
                  </span>
                </template>
              </v-radio>
            </div>
          </v-layout>
        </v-radio-group>
        <label>Вопрос</label>
        <v-text-field
          v-model="fields.title"
          height="48"
          solo
          :rules="[rules.required]"
        >
        </v-text-field>
        <div v-if="type !== 'grade'">
          <div v-for="(answer, index) in answers" :key="index">
            <div class="layout px-3 mt-0">
              <label>Ответ {{ index + 1 }}</label>
              <div
                @click="deleteAnswer(index)"
                class="flex text-sm-right subtitle-2 link pa-0"
              >
                Удалить
              </div>
            </div>
            <v-text-field
              v-model="answer.title"
              height="48"
              solo
              :rules="[rules.required]"
            >
            </v-text-field>
          </div>
        </div>
        <label v-if="type !== 'grade'">Ответ {{ answers.length + 1 }}</label>
        <div class="d-flex" v-if="type !== 'grade'">
          <v-text-field
            v-model="answer"
            height="48"
            solo
            class="flex pa-0 md8 xl9"
          ></v-text-field>
          <v-btn
            @click="addAnswer"
            class="primary my-0 flex md4 xl3 mr-0 pa-0"
            style="height: 48px"
            placeholder="Текст ответа"
            outline
          >
            Добавить
          </v-btn>
        </div>
      </div>
    </v-flex>
    <v-flex md6 xs12>
      <v-layout>
        <v-flex lg8 xl7 sm7 md12 class="adv-set--datepicker">
          <label>Период проведения</label>
          <date-range-picker
            :range="range"
            :index="5"
            :isShowError="true"
            @update="changeDate($event)"
          ></date-range-picker>
        </v-flex>
      </v-layout>

      <div class="font-weight-medium">Кому показывать рекламу</div>
      <div class="checkBoxList pt-2">
        <v-checkbox
          v-model="fields.params.clients.new"
          label="Новым клиентам"
          hide-details
          onIcon=""
          offIcon=""
          class="font-weight-medium mt-1"
        ></v-checkbox>

        <v-checkbox
          v-model="fields.params.clients.again"
          label="Клиентам, пришедшим повторно"
          hide-details
          onIcon=""
          offIcon=""
          class="font-weight-medium"
        ></v-checkbox>

        <v-checkbox
          v-model="fields.params.clients.many"
          hide-details
          onIcon=""
          offIcon=""
          class="font-weight-medium clients-input-wrapper"
        >
          <template #label>
            <label>Клиентам, пришедшим более</label>
            <v-text-field
              class="clients-input"
              v-model="fields.params.clients.counts"
              mask="##"
              solo
              height="32"
            >
            </v-text-field>
            раз
          </template>
        </v-checkbox>
      </div>
      <div class="mt-3">
        <div class="font-weight-bold pb-2">
          Хот-споты, к которым применяется опрос
        </div>

        <div
          v-for="hotspot in hotspots"
          :key="hotspot.id"
          class="subtitle-1 text-no-wrap mt-3 mb-2 d-flex align-center"
        >
          <span class="valign-middle font-weight-bold flex-none">
            {{ hotspot.title }}
            <div class="text--secondary font-weight-medium text-capitalize">
              {{ hotspot.address }}
            </div>
          </span>
          <v-btn @click="deleteHotspot(hotspot.id)" icon class="flex-none my-0">
            <icon-close></icon-close>
          </v-btn>
        </div>

        <v-layout class="ma-0">
          <v-select
            :items="hotspotList"
            v-model="hotspotIdSelected"
            item-value="id"
            item-text="title"
            open-on-clear
            append-icon=""
            height="48"
            dense
            solo
          >
            <template #append>
              <icon-angle class="ma-0 link"></icon-angle>
            </template>
          </v-select>

          <v-btn
            @click="addHotspot"
            class="primary my-0"
            style="height: 48px"
            outline
            :disabled="!hotspotIdSelected"
          >
            Добавить
          </v-btn>
        </v-layout>
      </div>
    </v-flex>
    <v-flex xs12 class="pt-0">
      <v-btn @click="save" class="primary ml-0">Сохранить</v-btn>
    </v-flex>
  </v-form>
</template>
<script>
import IconAngle from "../icon/IconAngle.vue";
import IconClose from "../icon/IconClose.vue";
import DateRangePicker from "../common/DateRangePicker.vue";

export default {
  name: "PollSettings",

  components: {
    DateRangePicker,
    IconClose,
    IconAngle,
  },
  props: {
    // поля опроса
    poll: {
      type: Object,
    },
  },

  data: () => ({
    // ошибка
    error: "",
    // список ответов
    answers: [],
    // поля формы
    fields: {},
    // список хотспотов
    hotspots: [],
    // выбранный хотспот для добавления
    hotspotIdSelected: null,
    rules: {
      required: (v) => !!v.trim() || "Поле обязательно для заполнения",
      url: (v) =>
        /^(https?:\/\/)?([\w.-]+)\.([\w-]{2,8}.?)(\/[\w-.]*)*\/?$/.test(v) ||
        "Введенная строка не является ссылкой",
    },
    // даты опроса
    range: { startDate: null, endDate: null },
    // вариант ответа на вопрос
    answer: "",
    // // тип опроса
    type: "one",
  }),
  beforeMount() {
    if (this.poll.end && this.poll.start) {
      this.range.endDate = this.poll.end;
      this.range.startDate = this.poll.start;
    }
    this.type = this.poll.type;
    if (this.poll.id) this.answers = this.poll.polls;
    else this.answers = [...this.poll.polls];
    this.hotspots = this.poll.hotspots;
    this.fields = { ...this.poll };
  },
  watch: {
    poll() {
      this.fields = { ...this.poll };
      if (this.poll.id) this.answers = this.poll.polls;
      else this.answers = [...this.poll.polls];
      this.hotspots = this.poll.hotspots;
    },
  },
  computed: {
    // список доступных хотспотов
    hotspotList() {
      let items;
      if (this.hotspots) {
        items = this.$store.getters.hotspotList.filter(
          (item) =>
            !this.hotspots.map((hotspot) => hotspot.id).includes(item.id)
        );
      } else {
        items = [...this.$store.getters.hotspotList];
      }
      return items;
    },
    pollMobile() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    },
    // тип опроса можно редактировать без ограничений только при создании
    // при редактирование тип можно менять между собой если
    // тип ответов один/несколько
    // на тип оценить менять нельзя
    // если тип оценить, то тип при редактировании менять нельзя
    disabledOneMore() {
      if (this.poll.id && this.poll.type !== "grade") return false;
      else if (this.poll.id && this.poll.type === "grade") return true;
      else return false;
    },
    disabledGrade() {
      if (this.poll.id && this.poll.type !== "grade") return true;
      else if (this.poll.id && this.poll.type === "grade") return false;
      else return false;
    },
  },

  methods: {
    // возвращает все папаметры для сохранения опроса
    getParamForSave() {
      let params = {};
      params.poll = this.fields;
      params.poll.end = this.range.endDate;
      params.poll.start = this.range.startDate;
      params.poll.type = this.type;
      // тип опроса можно менять только при создании
      // при редактировании тип опроса можно менять только если он
      // one/more между собой
      // если тип grade - менять тип нельзя
      if (this.type === "grade" && !this.fields.id)
        params.answers = [
          { title: "5 звёзд" },
          { title: "4 звезды" },
          { title: "3 звезды" },
          { title: "2 звезды" },
          { title: "1 звезда" },
        ];
      else params.answers = this.answers;
      return params;
    },
    save() {
      if (this.$refs.form.validate()) {
        const params = this.getParamForSave();
        this.$emit("save", params);
      }
    },
    /**
     * Добавить вариант ответа
     */
    addAnswer() {
      let newAnswer = { title: this.answer };
      if (this.poll.id) newAnswer.parent_id = this.poll.id;
      this.answers.push(newAnswer);
      this.answer = "";
    },
    // удалить вариант ответа
    deleteAnswer(index) {
      // если есть id удалить из бд
      if (this.answers[index].id)
        this.$emit("deleteAnswer", {
          id: this.answers[index].id,
          index: index,
        });
      else this.answers.splice(index, 1);
    },
    // добавление опроса к хоспоту
    addHotspot() {
      if (this.$refs.form.validate()) {
        let params = {};
        if (!this.poll.id) {
          params = this.getParamForSave();
        }
        params.hotspot_id = this.hotspotIdSelected;
        this.$emit("addHotspot", params);
        this.hotspotIdSelected = null;
      }
    },
    // открепление опроса от хотспота
    deleteHotspot(id_hotspot) {
      this.$emit("deleteHotspot", id_hotspot);
    },
    // обновляем дату
    changeDate(range) {
      this.range = range;
    },
  },
};
</script>
